module.exports = __webpack_public_path__ + "static/media/mira_search_ui_prototype1.5685f3df.gif";